import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { color, animation } from '../styles/helpers/variables';
import { Image } from '../styles/Image';
import { toCurrency } from '../util/toCurrency';
import { SITE_ROOT_URL } from '../constants/endpoints';
import { getProductVariantName } from '../util/getProductVariantName';
import { Conditional } from './Conditional';

const ProductConfigurationListItemMobile = props => {
  const tagKey = props.children.get('tags') && props.children.get('tags').toKeyedSeq();

  let relativePrice = null;
  if (!props.type) {
    relativePrice = (props.children.get('price') - props.price + props.totalSelectedOptionPrice !== 0) ? props.children.get('price') - props.price + props.totalSelectedOptionPrice : null;
  } else {
    relativePrice = (props.children.get('price') - props.selectedOptionPrice !== 0) ? props.children.get('price') - props.selectedOptionPrice : null;
  }
  let relativePricePrefix = null;
  if (relativePrice < 0) {
    relativePricePrefix = '-';
  } else if (relativePrice > 0) {
    relativePricePrefix = '+';
  }

  return (
    <ProductConfigurationListItemMobileContainer
      selected={props.type ? props.selected === props.children.get('id') : props.location === props.children.get('url')}
      onClick={() => props.setProductVariant(props.children.get('id'), props.type)}
    >
      <ProductConfigurationListItemMobileContent
        selected={
          props.type ? props.selected === props.children.get('id') : props.location === props.children.get('url')
        }
      >
        <Conditional show={tagKey && !tagKey.isEmpty()}>
          <TagIndicatorContainer>
            {tagKey && tagKey.map(item => <TagIndicator color={item.get('key')} />).toArray()}
          </TagIndicatorContainer>
        </Conditional>
        <Image
          style={{ flex: '0 0 auto' }}
          round={props.roundImages}
          url={
            SITE_ROOT_URL +
            (props.children.getIn(['mainImage', 'url'])
              ? props.children.getIn(['mainImage', 'url'])
              : props.children.getIn(['images', 0, 'url']))
          }
          width={50}
          height={50}
        />
        <Title>
          <Name>{getProductVariantName(props.children.get('cleanVariantName') || props.children.get('name'))}</Name>
          {props.children.get('inStock') && (
            <SelectOptionInStock>
              <SelectOptionInStockText>I lager</SelectOptionInStockText>
            </SelectOptionInStock>
          )}
          {relativePrice && (
            <Price>
              {relativePricePrefix && `${relativePricePrefix} `}
              {toCurrency(Math.abs(relativePrice))}
            </Price>
          )}
        </Title>
      </ProductConfigurationListItemMobileContent>
    </ProductConfigurationListItemMobileContainer>
  );
};

const TagIndicatorContainer = styled.div`
  width: 100%;
  height: 6px;
  position: absolute;
  top: 3px;
  left: 3px;
  display: flex;
`;

const TagIndicator = styled.div`
  width: 6px;
  height: 6px;
  margin-right: 2px;
  background-color: ${props => props.color};
`;

const Name = styled.span`
  flex: 1 1 auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const SelectOptionInStock = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin: 0 0 0 10px;
  color: #6a6a6a;
  font-size: 0.875em;
  &:last-child {
    margin: 0 10px;
  }
  &:before {
    content: '';
    flex: 0 0 auto;
    height: 5px;
    width: 5px;
    border-radius: 50%;
    background-color: ${color.success};
    @media screen and (min-width: 321px) {
      margin: 0 5px 0 0;
    }
  }
`;
const SelectOptionInStockText = styled.span`
  display: none;
  @media screen and (min-width: 321px) {
    display: inline;
  }
`;

const Price = styled.span`
  flex: 0 0 auto;
  padding: 0 10px;
  color: #6a6a6a;
  font-style: italic;
`;

const ProductConfigurationListItemMobileContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${color.white};
  width: 100%;
  height: 100%;
  padding: 2px 5px;
  transition: transform ${animation.transitionTime} ${animation.easing};

  ${props =>
    props.selected &&
    css`
      transform: translateX(20px);
      padding: 2px 20px 2px 5px;
    `} &:before {
    content: '';
    width: 12px;
    height: 12px;
    position: absolute;
    background-image: url('/images/icons/checkmark.svg');
    background-repeat: no-repeat;
    background-size: contain;
    left: -16px;
    display: block;
  }
`;

const ProductConfigurationListItemMobileContainer = styled.div`
  background-color: ${color.white};
  border: solid 1px #c5c5c5;
  border-bottom-color: transparent;
  overflow: hidden;
  width: 100%;
  margin: 0;
  cursor: pointer;
  max-height: 56px;

  &:last-of-type {
    border-bottom-color: #c5c5c5;
  }

  ${props =>
    props.selected &&
    css`
      border-color: ${color.primary} !important;
      background-color: ${color.primary};

      & + div {
        border-top-color: transparent;
      }
    `};
`;

const Title = styled.p`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  line-height: 1.57;
  text-align: left;
  color: ${color.black};
  margin: 0;
`;

ProductConfigurationListItemMobile.defaultProps = {
  roundImages: false,
  selected: '',
  type: null,
  price: null,
  selectedOptionPrice: null,
  totalSelectedOptionPrice: null,
};

ProductConfigurationListItemMobile.propTypes = {
  selected: PropTypes.string,
  setProductVariant: PropTypes.func.isRequired,
  roundImages: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  type: PropTypes.string,
  location: PropTypes.string.isRequired,
  price: PropTypes.number,
  selectedOptionPrice: PropTypes.number,
  totalSelectedOptionPrice: PropTypes.number,
};

export default ProductConfigurationListItemMobile;



// WEBPACK FOOTER //
// ./src/components/ProductConfigurationListItemMobile.js